
import React, { useState } from 'react';
import { Row, Col, Image, Space } from "antd";
import clsx from 'clsx';
import customStyles from "../../../../../assets/styles/customStyles";
import { NavLink } from "react-router-dom";
import { TextField } from "@mui/material";
import SearchIcon from "../../../../../assets/images/icon_actions/Search Icon.svg";
import DropDown from "../../../../../assets/images/icon_menus/Drop Down.svg";
import DropUp from "../../../../../assets/images/icon_menus/Drop Up.svg";
import { DesktopDatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import DateIcon from "../../../../Shared/components/Icons/Date";
import ExportIcon from "../../../../../assets/images/icon_actions/Export.svg";
import AddIcon from "../../../../../assets/images/icon_actions/Add Icon.svg";
import ClearIcon from "../../../../../assets/images/icon_actions/Clear Icon.svg";
import { idNamingConversion } from "../../../../../helpers/utilities";

export const TopBar = (props) => {
    const { roleManagement, checkComponentPermission,
        handleSearch, loadImportExportData,
        handleDates, handleNew, dateValue, search } = props;
    const [iconAnimation, setIconAnimation] = useState(false);
    const [picker, setPicker] = useState(false);



    const handlePicker = (picker) => {
        setPicker(picker);
        if (!picker) {
            handleDates([null, null], true);
        }
    }

    const classes = customStyles();
    return (
        <Row align="middle" className={classes.marginBottom20}>
            <Col xxl={6} xl={7} lg={8} md={10} sm={14} xs={24}>
                {
                    roleManagement !== '' && checkComponentPermission('Store Sales', 'Action', 'Search') &&
                    <div className={clsx(classes.searchAnimation, { [classes.iconAnimation]: iconAnimation || search !== '' })}>
                        <TextField autoComplete='one-time-code'
                            placeholder='Search'
                            type='search'
                            value={search}
                            onChange={(e) => handleSearch(e.target.value)}
                            className={classes.comInput}
                            variant={'standard'}
                            fullWidth
                            id={idNamingConversion('Search', 'storeSales', 'TextField')}
                            onFocus={() => setIconAnimation(true)}
                            onBlur={() => setIconAnimation(false)}
                        />
                        <Image src={SearchIcon} preview={false} />
                        {
                            search && <NavLink to="#" onClick={() => handleSearch('')} className={classes.searchClear}>
                                <Image
                                    src={ClearIcon}
                                    preview={false}
                                />
                            </NavLink>
                        }
                    </div>
                }
            </Col>
            <Col xxl={18} xl={17} lg={16} md={14} sm={10} xs={24} className={clsx(classes.textAlignRight, classes.vertiCalScrollOverFlowParent)}>
                <div className={classes.vertiCalScrollOverFlow}>
                    <Space direction="horizontal" align="center" size={[20, 20]}>
                        {
                            roleManagement !== '' && checkComponentPermission('Store Sales', 'Action', 'Date Filter') &&
                            <div className={clsx(classes.dateFilterwidth, classes.width250)}>
                                <Row>
                                    <Col span={24}>
                                        <NavLink to={'#'} id={idNamingConversion('Date Filter', 'storeSales', 'Link')} onClick={() => handlePicker(!picker)}
                                            className={clsx(classes.textAlignLeft, classes.dateFilter, classes.dropDownBorder, classes.dropDownWidth, classes.margint0, classes.dropDownPointer)}>
                                            Date Filter <Image
                                                src={picker ? DropUp : DropDown}
                                                preview={false} />
                                        </NavLink>
                                    </Col>
                                    {
                                        picker && <Col span={24}>
                                            <div className={clsx(classes.dateFilterdateAdjust)}>
                                                <LocalizationProvider dateAdapter={AdapterDateFns}>
                                                    <DesktopDatePicker
                                                        fullWidth
                                                        slots={{
                                                            openPickerIcon: DateIcon
                                                        }}
                                                        views={['year', 'month', 'day']}
                                                        allowKeyboardControl={false}
                                                        value={dateValue ? dateValue[0] : null}
                                                        label="From Date"
                                                        InputProps={{
                                                            classes: {
                                                                input: classes.textFieldColor,

                                                            },
                                                            //inputProps: { value: moment(startDate).format('DD/MM/YYYY'), readOnly: false }
                                                        }}
                                                        format="dd/MM/yyyy"
                                                        onChange={(newValue) => {
                                                            handleDates([newValue, dateValue[1]]);
                                                        }}
                                                        slotProps={{
                                                            textField: {
                                                                id: idNamingConversion('From Date', 'storeSales', 'TextField'),
                                                                autoComplete: 'one-time-code'
                                                            },
                                                        }}
                                                    />
                                                </LocalizationProvider>
                                                <LocalizationProvider dateAdapter={AdapterDateFns}>
                                                    <DesktopDatePicker
                                                        fullWidth
                                                        slots={{
                                                            openPickerIcon: DateIcon
                                                        }}
                                                        views={['year', 'month', 'day']}
                                                        allowKeyboardControl={false}
                                                        value={dateValue ? dateValue[1] : null}
                                                        minDate={new Date(dateValue ? dateValue[0] : null)}
                                                        label="To Date"
                                                        InputProps={{
                                                            classes: {
                                                                input: classes.textFieldColor
                                                            },
                                                            //inputProps: { value: moment(endDate).format('DD/MM/YYYY'), readOnly: false }
                                                        }}
                                                        format="dd/MM/yyyy"
                                                        onChange={(newValue) => {
                                                            handleDates([dateValue[0], newValue]);
                                                        }}
                                                        slotProps={{
                                                            textField: {
                                                                id: idNamingConversion('To Date', 'storeSales', 'TextField'),
                                                                autoComplete: 'one-time-code'
                                                            },
                                                        }}
                                                    />
                                                </LocalizationProvider>
                                            </div>
                                        </Col>
                                    }
                                </Row>
                            </div>
                        }
                        {
                            roleManagement !== '' && checkComponentPermission('Store Sales', 'Action', 'Export') &&
                            <NavLink
                                to="#"
                                id={idNamingConversion('Export', 'storeSales', 'Link')}
                                onClick={() => loadImportExportData('Store Sales')}
                                className={clsx(classes.customLink)}>
                                <Image
                                    src={ExportIcon}
                                    preview={false}
                                    className={clsx(classes.antImage)}
                                /> <span className={clsx(classes.addLink, classes.color, classes.bold)}>Export</span>
                            </NavLink>
                        }
                        {
                            roleManagement !== '' && checkComponentPermission('Store Sales', 'Action', 'Sales Return') &&
                            <NavLink
                                to={'#'}
                                id={idNamingConversion('Sales Return', 'storeSales', 'Link')}
                                onClick={() => handleNew('Sale Return')}
                                className={clsx(classes.customLink)}>
                                <Image src={AddIcon} preview={false} className={clsx(classes.antImage)} />
                                <span className={clsx(classes.addLink, classes.color, classes.bold)}>Sales Return</span>
                            </NavLink>
                        }
                        {
                            roleManagement !== '' && checkComponentPermission('Store Sales', 'Action', 'New Sales') &&
                            <NavLink
                                to={'#'}
                                id={idNamingConversion('New Sales', 'storeSales', 'Link')}
                                onClick={() => handleNew('Sale')}
                                className={clsx(classes.customLink)}>
                                <Image src={AddIcon} preview={false} className={clsx(classes.antImage)} />
                                <span className={clsx(classes.addLink, classes.color, classes.bold)}>New Sales</span>
                            </NavLink>
                        }
                    </Space>
                </div>
            </Col>
        </Row >
    )
}